/* eslint-disable */
export function throttle(fn, delay) {
  let previousTime = 0;
  return function ( ...args) {
    // eslint-disable-next-line prefer-rest-params
    const now  = Date.now();
    if (now - previousTime > delay) {
      fn.apply(this, args);
      previousTime = now;
    }
  };
};